import { Box, Typography } from '@mui/material';
import { easeOut, motion } from 'framer-motion';
import React from 'react';
import { theme } from '@shared/theme';

const fadeInVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: easeOut } },
};

function ReviewNotFound() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
    >
      <Box
        component={motion.div}
        initial="hidden"
        animate="visible"
        variants={fadeInVariants}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          background: theme.palette.background.paper,
          borderRadius: theme.spacing(1.5),
          padding: theme.spacing(2),
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
          width: '100%',
          maxWidth: 600,
          margin: 'auto',
          border: `0.5px solid ${theme.palette.primary.main}`,
        }}
      >
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            marginBottom: theme.spacing(1),
          }}
        >
          Deal Retro Not Found
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            color: theme.palette.text.secondary,
          }}
        >
          We couldn't find the deal retro you're looking for.
        </Typography>
      </Box>
    </Box>
  );
}

export default ReviewNotFound;
